import React from "react";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { Alert, Tag } from "antd";
import AntTable from "components/UI/AntTable";

const IBPortfolio = ({ portfolioData, showSensitiveValues }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const maskValue = (value) => {
    if (!showSensitiveValues && typeof value === "number") {
      return "••••••";
    }
    return value;
  };

  const columns = [
    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
      render: (symbol) => (
        <span style={{ fontWeight: "bold", fontSize: "16px" }}>{symbol}</span>
      ),
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
      render: (position) => (
        <Tag color={position > 0 ? "green" : position < 0 ? "red" : "default"}>
          {position > 0 ? "+" : ""}
          {position}
        </Tag>
      ),
    },
    {
      title: "Market Price",
      dataIndex: "marketPrice",
      key: "marketPrice",
      render: (price) =>
        showSensitiveValues ? formatCurrency(price) : maskValue(price),
    },
    {
      title: "Market Value",
      dataIndex: "marketValue",
      key: "marketValue",
      render: (value) =>
        showSensitiveValues ? formatCurrency(value) : maskValue(value),
    },
    {
      title: "Average Cost",
      dataIndex: "averageCost",
      key: "averageCost",
      render: (cost) =>
        showSensitiveValues ? formatCurrency(cost) : maskValue(cost),
    },
    {
      title: "Unrealized P&L",
      dataIndex: "unrealizedPNL",
      key: "unrealizedPNL",
      render: (pnl) => (
        <span
          style={{
            color:
              showSensitiveValues && pnl !== 0
                ? pnl > 0
                  ? "#52c41a"
                  : "#ff4d4f"
                : "",
            fontWeight: "bold",
          }}
        >
          {showSensitiveValues ? (
            <>
              {pnl > 0 && "+"}
              {formatCurrency(pnl)}
            </>
          ) : (
            maskValue(pnl)
          )}
        </span>
      ),
    },
    {
      title: "Realized P&L",
      dataIndex: "realizedPNL",
      key: "realizedPNL",
      render: (pnl) => (
        <span
          style={{
            color:
              showSensitiveValues && pnl !== 0
                ? pnl > 0
                  ? "#52c41a"
                  : "#ff4d4f"
                : "",
            fontWeight: "bold",
          }}
        >
          {showSensitiveValues ? (
            <>
              {pnl > 0 && "+"}
              {formatCurrency(pnl)}
            </>
          ) : (
            maskValue(pnl)
          )}
        </span>
      ),
    },
    {
      title: "Account",
      dataIndex: "account",
      key: "account",
      render: (account) => (
        <span style={{ fontSize: "12px", color: "#666" }}>{account}</span>
      ),
    },
  ];

  return (
    <GenericCard
      title="Portfolio"
      tooltipText="Current portfolio positions from Interactive Brokers"
      className="table-card"
    >
      <div style={{ padding: "16px 0" }}>
        {portfolioData.length === 0 ? (
          <Alert
            message="No Positions"
            description="No open positions found in your portfolio."
            type="info"
            showIcon
          />
        ) : (
          <AntTable
            columns={columns}
            dataSource={portfolioData}
            size="small"
            scroll={{ x: true }}
          />
        )}
      </div>
    </GenericCard>
  );
};

export default IBPortfolio;
